"use strict";

const initializeArcgisMap = () => {
    const mapContainer = document.querySelector(".arcgisMap");

    if (!mapContainer) return;

    const layerConfigs = JSON.parse(document.getElementById("arcgisMap-config").textContent);
    const i18n         = JSON.parse(document.getElementById("arcgisMap-i18n").textContent);

    const hexToRgba = (hex, alpha) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);

        return [r, g, b, alpha];
    };

    const applyRenderer = (layer, cfg) => {
        layer.renderer = {
            type: "simple",
            symbol: {
                type: "simple-fill",
                color: hexToRgba(cfg.fillColor, cfg.fillOpacity),
                outline: { color: hexToRgba(cfg.outlineColor, 1), width: 1 }
            }
        };
    };

    // Use bracket notation to prevent webpack from intercepting the ArcGIS AMD require
    var amdRequire = window["require"];

    amdRequire([
        "esri/Map",
        "esri/views/MapView",
        "esri/layers/VectorTileLayer",
        "esri/widgets/Search",
        "esri/widgets/ScaleBar",
        "esri/widgets/Home"
    ], (Map, MapView, VectorTileLayer, Search, ScaleBar, Home) => {
        const vectorTileLayers = layerConfigs.map((cfg) => {
            const layer = new VectorTileLayer({
                url: cfg.url,
                visible: cfg.defaultVisible,
                outFields: ["*"],
                popupEnabled: true,
                opacity: cfg.fillOpacity
            });

            applyRenderer(layer, cfg);
            return layer;
        });

        const map = new Map({ basemap: "streets-navigation-vector", layers: vectorTileLayers });

        const view = new MapView({
            container: "arcgisMap-mapDiv",
            map: map,
            center: [-40.3, -15.8],
            zoom: 10,
            ui: { components: ["zoom", "compass", "attribution"] }
        });

        const updateStatusBar = () => {
            document.getElementById("arcgisMap-zoomLevel").textContent = Math.round(view.zoom);
            document.getElementById("arcgisMap-mapScale").textContent  = "1:" + Math.round(view.scale).toLocaleString("pt-BR");
        };

        view.when(() => {
            view.ui.add(new Search({ view: view }), "top-right");
            view.ui.add(new ScaleBar({ view: view, unit: "metric" }), "bottom-left");
            view.ui.add(new Home({ view: view }), "top-left");
            updateStatusBar();

            Promise.all(vectorTileLayers.map((l) => l.load())).then(() => {
                const layerList = document.getElementById("arcgisMap-layerList");

                layerList.innerHTML = "";

                vectorTileLayers.forEach((layer, i) => {
                    const cfg = layerConfigs[i];

                    const item = document.createElement("div");

                    item.className = "arcgisMap__layerItem";

                    const topRow = document.createElement("div");

                    topRow.className = "arcgisMap__layerRow";

                    const dot = document.createElement("div");

                    dot.className        = "arcgisMap__layerDot";
                    dot.style.background = cfg.fillColor;

                    const info = document.createElement("div");

                    info.className = "arcgisMap__layerInfo";
                    info.innerHTML = `<div class="arcgisMap__layerName">${layer.title || i18n.layerFallback + " " + (i + 1)}</div>`;

                    const toggle = document.createElement("div");

                    toggle.className = "arcgisMap__toggle" + (layer.visible ? " arcgisMap__toggle--on" : "");
                    toggle.addEventListener("click", () => {
                        layer.visible = !layer.visible;
                        toggle.classList.toggle("arcgisMap__toggle--on", layer.visible);
                    });

                    topRow.appendChild(dot);
                    topRow.appendChild(info);
                    topRow.appendChild(toggle);

                    const controls = document.createElement("div");

                    controls.className = "arcgisMap__layerControls";

                    const fillRow = document.createElement("div");

                    fillRow.className = "arcgisMap__ctrlRow";

                    const fillSwatch = document.createElement("div");

                    fillSwatch.className = "arcgisMap__colorSwatch";

                    fillSwatch.style.background = cfg.fillColor;

                    const fillInput = document.createElement("input");

                    fillInput.type  = "color";
                    fillInput.value = cfg.fillColor;
                    fillInput.addEventListener("input", () => {
                        cfg.fillColor               = fillInput.value;
                        fillSwatch.style.background = fillInput.value;
                        dot.style.background        = fillInput.value;
                        applyRenderer(layer, cfg);
                    });
                    fillSwatch.appendChild(fillInput);

                    const opVal = document.createElement("span");

                    opVal.className   = "arcgisMap__ctrlVal";
                    opVal.textContent = Math.round(cfg.fillOpacity * 100) + "%";

                    const opSlider = document.createElement("input");

                    opSlider.type  = "range";
                    opSlider.min   = 0;
                    opSlider.max   = 100;
                    opSlider.value = Math.round(cfg.fillOpacity * 100);
                    opSlider.addEventListener("input", () => {
                        cfg.fillOpacity   = opSlider.value / 100;
                        opVal.textContent = opSlider.value + "%";
                        applyRenderer(layer, cfg);
                    });

                    fillRow.appendChild(fillSwatch);
                    fillRow.appendChild(opSlider);
                    fillRow.appendChild(opVal);

                    const outlineRow = document.createElement("div");

                    outlineRow.className = "arcgisMap__ctrlRow";
                    outlineRow.innerHTML = `<span class="arcgisMap__ctrlLabel">${i18n.outline}</span>`;

                    const outlineSwatch = document.createElement("div");

                    outlineSwatch.className        = "arcgisMap__colorSwatch";
                    outlineSwatch.style.background = cfg.outlineColor;

                    const outlineInput = document.createElement("input");

                    outlineInput.type  = "color";
                    outlineInput.value = cfg.outlineColor;
                    outlineInput.addEventListener("input", () => {
                        cfg.outlineColor               = outlineInput.value;
                        outlineSwatch.style.background = outlineInput.value;
                        applyRenderer(layer, cfg);
                    });
                    outlineSwatch.appendChild(outlineInput);
                    outlineRow.appendChild(outlineSwatch);

                    // controls.appendChild(fillRow);
                    // controls.appendChild(outlineRow);

                    item.appendChild(topRow);
                    // item.appendChild(controls);
                    layerList.appendChild(item);
                });

                // const opacitySlider = document.getElementById("arcgisMap-globalOpacity");
                // const opacityValEl  = document.getElementById("arcgisMap-opacityVal");

                // opacitySlider.addEventListener("input", () => {
                //     const val = opacitySlider.value / 100;

                //     opacityValEl.textContent = opacitySlider.value + "%";
                //     featureLayers.forEach((l) => { l.opacity = val; });
                // });

            }).catch((err) => {
                document.getElementById("arcgisMap-layerList").innerHTML =
                        `<div style="font-size:12px;color:#e06060;">${i18n.errorLoadLayers} ${err.message}</div>`;
            });
        });

        view.watch("zoom",  updateStatusBar);
        view.watch("scale", updateStatusBar);

        view.on("pointer-move", (evt) => {
            const pt = view.toMap({ x: evt.x, y: evt.y });

            if (pt) {
                document.getElementById("arcgisMap-coordLat").textContent = pt.latitude.toFixed(4);
                document.getElementById("arcgisMap-coordLon").textContent = pt.longitude.toFixed(4);
            }
        });

        document.querySelectorAll(".arcgisMap__basemapBtn").forEach((btn) => {
            btn.addEventListener("click", () => {
                document.querySelectorAll(".arcgisMap__basemapBtn").forEach((b) => {
                    b.classList.remove("arcgisMap__basemapBtn--active");
                });
                btn.classList.add("arcgisMap__basemapBtn--active");
                map.basemap = btn.dataset.basemap;
            });
        });
    }
    );

    const menuBtn = document.getElementById("arcgisMap-menuBtn");
    const sidebar = document.querySelector(".arcgisMap__sidebar");

    if (menuBtn && sidebar) {
        menuBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            const isOpen = sidebar.classList.toggle("arcgisMap__sidebar--open");

            menuBtn.classList.toggle("arcgisMap__menuBtn--open", isOpen);
            menuBtn.setAttribute("aria-expanded", String(isOpen));
        });

        document.addEventListener("click", (e) => {
            if (!sidebar.contains(e.target) && !menuBtn.contains(e.target)) {
                sidebar.classList.remove("arcgisMap__sidebar--open");
                menuBtn.classList.remove("arcgisMap__menuBtn--open");
                menuBtn.setAttribute("aria-expanded", "false");
            }
        });
    }
};

export default initializeArcgisMap;
